import React from 'react'
import Sketch from 'react-p5'
import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

let strings = new LocalizedStrings({
    en:{
        title: "complexity",
        str: "selfsimilarnotequal",
        description: ""
    },
    de:{
        title: "komplexität",
        str: "selbstähnlichnichtgleich",
        description: ""
    }
})

class Complexity extends React.Component {
    constructor(props) {
        super(props)
        this.speedUp = 3
        this.scalex = 29/2
        this.scaley = 29/2
        this.strPos = 0
        this.x = 0
        this.y = 0
        this.z = 0
        this.h = 0

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)

        this.state = {str: strings.str}
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    componentWillReceiveProps(props) {
        const { language } = this.props;

        if (props.language !== language) {
            strings.setLanguage(props.language)
            this.reset(this.p5)
        }
    }

    nextCh() {
        var ch = this.state.str.substring(this.strPos, this.strPos+1)
        this.strPos = (this.strPos + 1) % this.state.str.length

        return ch
    }

    f(x,y,z) {
        const sigma = 3
        const rho = 26.5
        const beta = 1
        return [sigma*(y-x), -x*z + rho*x - y, x*y - beta*z]
    }

    reset(p5) {
        p5.background(0)

        p5.textFont("DejaVuSerif");

        p5.randomSeed(p5.millis())

        const _h = 0.02

        var x0 = 0.0
        var y0 = 1.0
        var z0 = 0.0

        // add random number between -0.25 and 0.25
        this.x = x0 + (p5.random()-0.5)/2
        this.y = y0 + (p5.random()-0.5)/2
        this.z = z0 + (p5.random()-0.5)/2

        this.h = _h
        // dismiss the first 100 points
        // to go into the attractor
        for (var i=1; i < 100; i++) {
            var m = this.f(this.x,this.y,this.z)
            this.x = this.x + this.h * m[0]
            this.y = this.y + this.h * m[1]
            this.z = this.z + this.h * m[2]
        }
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        this.reset(p5)
        this.p5 = p5
    }

    calcPoint(p5) {
        var m = this.f(this.x,this.y,this.z)
        this.x = this.x + this.h * m[0]
        this.y = this.y + this.h * m[1]
        this.z = this.z + this.h * m[2]
        //print("("..x..","..y..","..z..")")
        p5.fill(255,255,255,255*0.8)
        p5.push()
        p5.textSize(this.z/2)
        p5.text(this.nextCh(), p5.width/2+this.scalex*this.x, p5.height/2+this.scaley*this.y)
        p5.pop()
    }

  draw(p5) {
      for (var i = 0; i < this.speedUp; i++) {
          this.calcPoint(p5)
      }
  }

  windowResized(p5) {
      p5.resizeCanvas(window.innerWidth, window.innerHeight)
      this.reset(p5)
  }

  generate() {
      if (this.state.generatedLanguage !== this.context.language) {
          this.setState({
              str: strings.str, generatedLanguage: this.context.language
          });
      }
  }

  render() {
      strings.setLanguage(this.context.language)
      this.generate()

      return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
  }
}
Complexity.contextType = LanguageContext

export default Complexity
